import { atom } from "recoil";

import CurrencyData = App.Data.CurrencyData;

interface TenantState {
    slug_name: string | null;
    currency: CurrencyData | null;
}

export const tenantAtom = atom<TenantState>({
    key: "tenantAtom",
    default: {
        slug_name: null,
        currency: null,
    },
});
